import { render } from "./insurance-detail.vue?vue&type=template&id=80161418&scoped=true&ts=true"
import script from "./insurance-detail.vue?vue&type=script&lang=ts"
export * from "./insurance-detail.vue?vue&type=script&lang=ts"

import "./insurance-detail.vue?vue&type=style&index=0&id=80161418&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80161418"]])

export default __exports__